import React from 'react'

import history from "../services/history"
import { COLOR, FORMATTING, JARGON, KEY_VALUES, PATH } from "../modules/constants"

import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"

const { border1 } = FORMATTING

const footerBarSx = {
  height: `${KEY_VALUES.FOOTER_HEIGHT}px`,
  width: "100%",
  position: "relative",
  backgroundColor: COLOR.VERY_LIGHT_GREY,
  color: "grey",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  borderTop: border1,
}

const footerTextSx = {
  marginTop: '8px',
  display: "block",
  verticalAlign: "middle",
  fontSize: 14,
  fontWeight: 400,
}

const footerButtonSx = {
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 500,
  textTransform: "none",
  color: "grey",
  border: "none",
  outline: "none",
  backgroundColor: "transparent",
  textDecoration: "underline",
  verticalAlign: "middle",
  marginTop: '0px',
  marginLeft: '10px',
  minWidth: 'auto',
  padding: '0 4px',
  '&:hover': {
    backgroundColor: "transparent",
    textDecoration: "underline",
  },
}

const Footer = ({ urlSource }) => {
  const hrefWebHomePage = `https://www.numerable.io/?utm_source=${urlSource}&utm_medium=numapp&utm_campaign=footer`
  const hrefWebContactPage = `https://www.numerable.io/contact/?utm_source=${urlSource}&utm_medium=numapp&utm_campaign=footer`

  return (
    <Box sx={footerBarSx}>
      <Typography component="div" sx={footerTextSx}>
        © 2026
        <Button
          href={hrefWebHomePage}
          sx={footerButtonSx}
          target="_blank"
          rel="noopener noreferrer">
          Numerable Software Ltd
        </Button>

        {urlSource === JARGON.THE350CLUB && " - in partnership with The 350 Club"}

        <Button sx={footerButtonSx} onClick={() => history.push(`/${PATH.ABOUT}`)}>About</Button>

        <Button sx={footerButtonSx} onClick={() => history.push(`/${PATH.PRIVACY}`)}>Privacy</Button>

        <Button sx={footerButtonSx} onClick={() => history.push(`/${PATH.T_AND_C}`)}>Terms</Button>

        <Button
          href={hrefWebContactPage}
          sx={footerButtonSx}
          target="_blank"
          rel="noopener noreferrer">
          Contact
        </Button>

      </Typography>
    </Box>
  )
}

export default Footer
